import React from "react";
import ICONS from "../../constants/icons";

import DashboardWidget from "./DashboardWidget";
import { FlexWrapper } from "./components";
// import { SensorContext } from "../../contexts/SensorContext";

const DashboardWidgets = () => {
  // const { temperature, humidity, battery } = useContext(SensorContext);

  return (
    <FlexWrapper>
      <DashboardWidget
        icon={<ICONS.DashboardTemperature />}
        color="#0686D833"
        label="Temperature"
        // value={temperature ? `${temperature}c` : "N/A"}
      />
      <DashboardWidget
        icon={<ICONS.DashboardHumidity />}
        color="#D000004a"
        label="Humidity"
        // value={humidity ? `${humidity}%` : "N/A"}
      />
      <DashboardWidget
        icon={<ICONS.DashboardBattery />}
        color="#33CA7F33"
        label="Battery"
        // value={battery ? `${battery}%` : "N/A"}
      />
    </FlexWrapper>
  );
};

export default DashboardWidgets;
